import type { AttackResult } from "../types/combat.js";
import { rollD20 } from "./dice.js";

export interface AttackInput {
  abilityModifier: number;
  proficiencyBonus: number;
  targetAC: number;
  /** Flat bonus to hit (e.g. +5 from Invisible attacker). Replaces adv/disadv for v1. */
  hitBonus?: number;
}

/**
 * Resolves a 5e SRD attack roll.
 * Pure function — no side effects. Caller checks `.hit` before calling `resolveDamage`.
 */
export function resolveAttackRoll(input: AttackInput): AttackResult {
  const d20 = rollD20();

  const isCriticalHit = d20 === 20;
  const isCriticalMiss = d20 === 1;
  const total = d20 + input.abilityModifier + input.proficiencyBonus + (input.hitBonus ?? 0);
  const hit = isCriticalHit || (!isCriticalMiss && total >= input.targetAC);

  return {
    d20,
    abilityModifier: input.abilityModifier,
    proficiencyBonus: input.proficiencyBonus,
    total,
    isCriticalHit,
    isCriticalMiss,
    hit,
  };
}
